import { gql } from 'apollo-angular';

export const mutationQuestionRespond = gql`
mutation questionPostResponse ($ID: String, $params: String ) { 
    QuestionPostResponse(ID: $ID, params: $params )
}
`;

export const queryQuestionsCommunity = gql`
query QuestionsCommunity($widgetID: String){
  QuestionsCommunity(widgetID: $widgetID){
    ID
    product {
      name
    }
    tester{
      firstName
      lastName
    }
    object
    content
    responses {
        ambassadorID
        response
        responseDate
    }    
    status
    _ {
      created
    }
  }
}`;